import { useContext } from 'react'

import { sessionContext } from '@contexts/session'

export function useSession() {
  return useContext(sessionContext)
}
